import React from 'react';
import {
  UpdateFilesGeneric,
  DeleteFilesGeneric,
} from '../gqlSchemes/filesGeneric';
import { useMutation } from '@apollo/client';

function useFiles() {
  const [updateFilesGeneric, { loading }] = useMutation(UpdateFilesGeneric);
  const [deleteFilesGeneric] = useMutation(DeleteFilesGeneric);

  const onPreSave = async (variables) => {
    try {
      const { data } = await updateFilesGeneric({ variables });
      if (!data?.uploadFile?.createFiles?.ok)
        return { error: 'Oops, something went wrong :(' };
      return data?.uploadFile?.createFiles?.result?.files;
    } catch (e) {
      return e.message;
    }
  };

  const onRemove = async (variables) => {
    try {
      const { data } = await deleteFilesGeneric({ variables });
      return data;
    } catch (e) {
      return e.message;
    }
  };

  return {
    onPreSave,
    onRemove,
    loading,
  };
}

export default useFiles;
